import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import styled from 'styled-components';

const ImageFluidStyled = styled(Img)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ImgStyled = styled('img')`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;


/**
 * ImageFluid component
 * @param {Object} props.fluid - fluid object
 * @param {Object} props.topAlign - if true, image will be aligned top in mobile
 * @returns {JSX}
 */
const ImageFluid = ({ fluid, imgStyle, alt }) => {
  if (typeof fluid === 'string' || fluid instanceof String) {
    return <ImgStyled src={fluid} fluid={fluid} alt={alt} style={imgStyle} />;
  }
  return <ImageFluidStyled src={fluid} fluid={fluid} alt={alt} imgStyle={imgStyle} />;
};

ImageFluid.propTypes = {
  fluid: PropTypes.object,
  imgStyle: PropTypes.object,
  alt: PropTypes.string
};

export default ImageFluid;
